import { io, Socket } from 'socket.io-client';

export { io, Socket };
